/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Danger_Deleteaccountdesc2Inputs */

const zh_danger_deleteaccountdesc2 = /** @type {(inputs: Danger_Deleteaccountdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`永久删除您的账户及所有相关数据。此操作不可恢复。`)
};

const en_danger_deleteaccountdesc2 = /** @type {(inputs: Danger_Deleteaccountdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permanently delete your account and all associated data. This action cannot be undone.`)
};

const es_danger_deleteaccountdesc2 = /** @type {(inputs: Danger_Deleteaccountdesc2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina permanentemente tu cuenta y todos los datos asociados. Esta acción no se puede deshacer.`)
};

/**
* | output |
* | --- |
* | "Permanently delete your account and all associated data. This action cannot be undone." |
*
* @param {Danger_Deleteaccountdesc2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const danger_deleteaccountdesc2 = /** @type {((inputs?: Danger_Deleteaccountdesc2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Danger_Deleteaccountdesc2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_danger_deleteaccountdesc2(inputs)
	if (locale === "en") return en_danger_deleteaccountdesc2(inputs)
	return es_danger_deleteaccountdesc2(inputs)
});
export { danger_deleteaccountdesc2 as "danger_deleteAccountDesc" }